/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Translation_ModalInputs */

const en_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Translation Modal`)
};

const fr_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre de traduction`)
};

const de_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsmodal schließen`)
};

const it_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale di traduzione`)
};

const ru_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно перевода`)
};

const es_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar modal de traducción`)
};

const zh_cn2_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近译模态`)
};

const ja_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳モーダルを閉じる`)
};

const hi_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद बंद करें`)
};

const pt_pt2_close_translation_modal = /** @type {(inputs: Close_Translation_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Modal de Tradução`)
};

/**
* | output |
* | --- |
* | "Close Translation Modal" |
*
* @param {Close_Translation_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_translation_modal = /** @type {((inputs?: Close_Translation_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Translation_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_translation_modal(inputs)
	if (locale === "de") return de_close_translation_modal(inputs)
	if (locale === "it") return it_close_translation_modal(inputs)
	if (locale === "ru") return ru_close_translation_modal(inputs)
	if (locale === "es") return es_close_translation_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_translation_modal(inputs)
	if (locale === "ja") return ja_close_translation_modal(inputs)
	if (locale === "hi") return hi_close_translation_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_translation_modal(inputs)
	return en_close_translation_modal(inputs)
});